import { useState } from "react";
import { Pencil, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { WaButtons } from "@/components/WaButtons";

const EditModal = ({ r, students, close, saved }) => {
  const [f, setF] = useState({ student_id: r.student_id, date: r.date, category: r.category, kind: r.kind, description: r.description, follow_up: r.follow_up || "-", verification: r.verification || "Menunggu" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { await api(`/discipline/${r.id}`, { method: "PUT", body: JSON.stringify(f) }); toast.success("Catatan disiplin diperbarui"); saved(); close(); }
    catch (err) { toast.error(err.message); }
  };
  return (
    <div className="modal-backdrop" onClick={(e) => e.stopPropagation()}><div className="modal" data-testid="edit-discipline-modal">
      <div className="modal-head"><h3>Edit catatan disiplin</h3><button onClick={close} data-testid="edit-discipline-close"><X size={18} /></button></div>
      <form className="modal-form" onSubmit={submit}>
        <label>Nama siswa<select required value={f.student_id} onChange={set("student_id")} data-testid="edit-discipline-student">{!students.some((s) => s.id === r.student_id) && <option value={r.student_id}>{r.student_name} · {r.class_name}</option>}{students.map((s) => <option key={s.id} value={s.id}>{s.name} · {s.class_name}</option>)}</select></label>
        <label>Tanggal<input type="date" required value={f.date} onChange={set("date")} data-testid="edit-discipline-date" /></label>
        <label>Kategori<input required value={f.category} onChange={set("category")} data-testid="edit-discipline-category" /></label>
        <label>Jenis<select value={f.kind} onChange={set("kind")} data-testid="edit-discipline-kind"><option>Positif</option><option>Perlu pembinaan</option></select></label>
        <label>Uraian<textarea required value={f.description} onChange={set("description")} data-testid="edit-discipline-description" /></label>
        <label>Tindak lanjut<input value={f.follow_up} onChange={set("follow_up")} data-testid="edit-discipline-followup" /></label>
        <label>Status<select value={f.verification} onChange={set("verification")} data-testid="edit-discipline-verification"><option>Menunggu</option><option>Terverifikasi</option></select></label>
        <button className="primary-btn full" data-testid="edit-discipline-save">Simpan perubahan</button>
      </form>
    </div></div>
  );
};

const DeleteModal = ({ r, close, saved }) => {
  const remove = async () => {
    try { await api(`/discipline/${r.id}`, { method: "DELETE" }); toast.success("Catatan disiplin dihapus"); saved(); close(); }
    catch (err) { toast.error(err.message); }
  };
  return (
    <div className="modal-backdrop" onClick={(e) => e.stopPropagation()}><div className="modal" data-testid="delete-discipline-modal">
      <div className="modal-head"><h3>Hapus catatan?</h3><button onClick={close} data-testid="delete-discipline-close"><X size={18} /></button></div>
      <div className="modal-form"><p className="muted">Catatan <b>{r.category}</b> untuk <b>{r.student_name}</b> ({r.date}) akan dihapus permanen{r.source === "scan" ? ", termasuk data scan kehadirannya" : ""}.</p>
        <div className="row-actions"><button className="outline-btn" onClick={close} data-testid="delete-discipline-cancel">Batal</button><button className="primary-btn danger-btn" onClick={remove} data-testid="delete-discipline-confirm"><Trash2 size={16} /> Hapus</button></div></div>
    </div></div>
  );
};

export const DisciplineActions = ({ r, admin, students, reload }) => {
  const [modal, setModal] = useState(null);
  const open = (m) => (e) => { e.stopPropagation(); setModal(m); };
  return (
    <span className="row-actions record-actions">
      <WaButtons r={r} />
      {admin && <>
        <button className="mini-btn" onClick={open("edit")} data-testid={`edit-discipline-${r.id}`}><Pencil size={13} /> Edit</button>
        <button className="mini-btn danger" onClick={open("delete")} data-testid={`delete-discipline-${r.id}`}><Trash2 size={13} /> Hapus</button>
      </>}
      {modal === "edit" && <EditModal r={r} students={students} close={() => setModal(null)} saved={reload} />}
      {modal === "delete" && <DeleteModal r={r} close={() => setModal(null)} saved={reload} />}
    </span>
  );
};
